import './index.css';

export default ({value, clickHandler, width, color}) => {
    return(
        <div className='Button' onClick={clickHandler} style={{width: width, color: color}}>
            <div className='Button__inner1' style={{borderColor: color}}><span style={{marginTop: '5px'}}>{value}</span></div>
            <div className='Button__inner2' style={{borderColor: color}}></div>
        </div>
    );
}